import axios from "axios";
import { ADD_QUOTATION, GET_QUOTATION,DOWNLOAD_PDF, GET_SINGLE_QUOTATION } from "../config/urlConfig";
import { saveAs } from "file-saver";
import moment from 'moment';
// Function for handling ADD & EDIT  quotation  api
export async function handleAddEditQuotationApi(quotData, token) {
    try {

      let response = await axios.post(ADD_QUOTATION, quotData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
  
      return response.data;
    } catch (error) {
      if (error?.response) {

  
        return error.response.data;
      }
      console.log(error.message);
    }
  }

  // Function for fetch all quotation
export async function getAllQuotationApi(token,  page, itemsPerPage) {
  try {
    const params =  new URLSearchParams();
    params.append('page',page)
    params.append('limit', itemsPerPage)
    let response = await axios.get(`${GET_QUOTATION}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}


export async function generatePdfApi(quotId, quotRefNumber, subject, version) {
  const formattedDate = moment().format('YYYYMMDD');
  let response =  await axios.get(`${DOWNLOAD_PDF}/${quotId}`,
      {
          responseType : 'blob'
      }
  )

  if( response.status ==200){
  const bufferData = response.data
      const blob = new Blob([bufferData], {
          type: "application/pdf",
      });
  
    // Use file-saver to save the file
    saveAs(blob, `Quote-${quotRefNumber}-${subject}-V${version}-${formattedDate}`);
  }
}

export async function fetchSingleQuotationApi(token, quotId, isExcel) {
    try {
    
      let response = await axios.get(`${GET_SINGLE_QUOTATION}/${quotId}?isExcel=${isExcel}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error?.response) {
        console.log(error.response.data);

        return error.response.data;
      }
      console.log(error.message);
    }
}

